import { useLocation, useParams, useRoutes } from "react-router-dom";

import TaskEditPage from "./edit";
import JobViewPage from "./job/view";
import TaskListPage from "./list";
import TaskViewPage from "./view";

export default () =>
  useRoutes([
    { path: "/:taskId/job/:jobId", element: <WithParameters component={JobViewPage}/> },
    { path: "/:taskId/edit", element: <WithParameters component={TaskEditPage}/> },
    { path: "/:taskId", element: <WithParameters component={TaskViewPage}/> },
    { path: "/", element: <WithParameters component={TaskListPage}/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  const loc = useLocation();
  return <Comp {...parameters} location={loc}/>;
}
